// removed by extract-text-webpack-plugin
module.exports = {"table":"_3azx2y1zif6G4fklDIfpbQ"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/PersonalCenterCompanyInfo/PersonalCenterCompanyInfo.scss
 ** module id = 1087
 ** module chunks = 0
 **/